module.exports = __webpack_public_path__ + "img/Arial.ceacfc7d.png";